/* eslint-disable no-case-declarations */
import { put, select, takeLatest } from 'redux-saga/effects'
import { DatasetDeterminationConstants, IConfigurationsState } from '../store/configurations.types'
import { ConfigurationsConstants } from '../store/configurations.constants'
import { getConfigurationsSelector } from '../selectors'
import * as actions from '../store/configurations.actions'
import { PickupAddressConstants } from '../../pickupAddress/store/pickupAddress.constants'
import { DestinationAddressConstants } from '../../destinationAddress/store/destinationAddress.constants'
import { TripInformationConstants } from '../../tripInformation/store/tripInformation.constants'
import { getTripInformationSelector } from '../../tripInformation/selectors'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { getPickupAddressSelector } from '../../pickupAddress/selectors'
import { IPickupAddressState } from '../../pickupAddress/store/pickupAddress.types'
import { IDispositionState } from '../../destinationAddress/store/destinationAddress.types'
import { getDestinationAddressSelector } from '../../destinationAddress/selectors/destinationAddress.selectors'
import { updateDatasetDeterminationConfig } from '../utils/configurations.util'

export function* setExportDatasets() {
  const { datasetDeterminationConfig }: IConfigurationsState = yield select(getConfigurationsSelector)
  if (!datasetDeterminationConfig) return

  let updatedConfig = datasetDeterminationConfig
  let datasetsList: Array<string> = []

  const { activateNemsis, datasetDetermination, defaultDataset } = datasetDeterminationConfig
  const { base, unit }: ITripInformationState = yield select(getTripInformationSelector)
  const { state: pickupState }: IPickupAddressState = yield select(getPickupAddressSelector)
  const {
    destination: { state: destinationState },
  }: IDispositionState = yield select(getDestinationAddressSelector)

  // If activateNemsis is not set to "Yes", no datasets can be selected for export
  if (!activateNemsis) return

  switch (datasetDetermination) {
    case DatasetDeterminationConstants.BY_DEFAULT_DATASET:
      datasetsList = [defaultDataset || '']
      updatedConfig = updateDatasetDeterminationConfig(updatedConfig, datasetsList)
      break
    case DatasetDeterminationConstants.BY_BASE_SITE:
      datasetsList = [base?.state || '']
      updatedConfig = updateDatasetDeterminationConfig(updatedConfig, datasetsList)
      break
    case DatasetDeterminationConstants.BY_UNIT_STATE:
      datasetsList = [unit?.state || '']
      updatedConfig = updateDatasetDeterminationConfig(updatedConfig, datasetsList)
      break
    case DatasetDeterminationConstants.BY_REF_STATE:
      datasetsList = [pickupState?.id?.toString() || '']
      updatedConfig = updateDatasetDeterminationConfig(updatedConfig, datasetsList)
      break
    case DatasetDeterminationConstants.BY_REC_STATE:
      datasetsList = [destinationState?.id?.toString() || '']
      updatedConfig = updateDatasetDeterminationConfig(updatedConfig, datasetsList)
      break
    case DatasetDeterminationConstants.BY_REF_AND_REC_STATE:
      datasetsList = [pickupState?.id?.toString() || '', destinationState?.id?.toString() || '']
      updatedConfig = updateDatasetDeterminationConfig(updatedConfig, datasetsList)
      break
    case DatasetDeterminationConstants.BY_BASE_SITE_REGION:
      datasetsList = [base?.regionState || '']
      updatedConfig = updateDatasetDeterminationConfig(updatedConfig, datasetsList)
      break
  }

  yield put(actions.setDatasetDeterminationConfig(updatedConfig))
}
export function* setExportDatasetsSaga() {
  yield takeLatest(
    [
      ConfigurationsConstants.SET_INITIAL_EXPORT_DATASETS,
      TripInformationConstants.SET_BASE,
      TripInformationConstants.SET_UNIT,
      PickupAddressConstants.SET_STATE,
      DestinationAddressConstants.SET_STATE,
    ],
    setExportDatasets
  )
}
